var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.activeErrors.has(_vm.field))?_c('span',{staticClass:"form-error error-text"},[_vm._v(" "+_vm._s(_vm.activeErrors.first(_vm.field))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }